import React, { Fragment } from "react";
import { Helmet } from "react-helmet";

import CampaignForm from "../../components/page/clientCampaign/CampaignForm/CampaignForm";

const CampaignPage = (props) => {
  let title = props.edit ? <title>Boxi Admin | Edit Campaign</title> : <title>Boxi Admin | Create Campaign</title>;
  return (
    <Fragment>
      <Helmet>{title}</Helmet>
      <CampaignForm edit={props.edit} />
    </Fragment>
  );
};

export default CampaignPage;
